export function getStrongAuthStatus(payload = {}) {
  const strongAuth = payload?.strongAuth && typeof payload.strongAuth === "object"
    ? payload.strongAuth
    : {};

  return {
    strongAuthRequired: strongAuth.strongAuthRequired === true || payload?.strongAuthRequired === true,
    strongAuthEnrolled: strongAuth.strongAuthEnrolled === true || payload?.strongAuthEnrolled === true,
    enrollmentRequired:
      strongAuth.enrollmentRequired === true || payload?.mfaEnrollmentRequired === true,
    availableAuthMethods: Array.isArray(strongAuth.availableAuthMethods)
      ? strongAuth.availableAuthMethods
      : Array.isArray(payload?.availableAuthMethods)
        ? payload.availableAuthMethods
        : [],
    authenticatedWith: strongAuth.authenticatedWith || payload?.authenticatedWith || null,
    strongAuthVerifiedAt: strongAuth.strongAuthVerifiedAt || payload?.strongAuthVerifiedAt || null,
    recoveryRequired: strongAuth.recoveryRequired === true || payload?.recoveryRequired === true,
    rolloutMode: strongAuth.rolloutMode || payload?.rolloutMode || null,
    transitionGraceActive:
      strongAuth.transitionGraceActive === true || payload?.transitionGraceActive === true,
  };
}

export function isStrongAuthEnrollmentRequired(payload) {
  return getStrongAuthStatus(payload).enrollmentRequired;
}

export function getDefaultAuthenticatedRoute(payload) {
  if (String(payload?.accountType || "internal").trim().toLowerCase() === "customer_portal") {
    return "/portaal";
  }

  const roles = [
    ...(Array.isArray(payload?.roles) ? payload.roles : []),
    payload?.rol,
    payload?.role,
  ]
    .map((role) => (typeof role === "object" ? role?.name || role?.naam : role))
    .map((role) => String(role || "").trim().toLowerCase())
    .filter(Boolean);

  if (roles.includes("platformadmin")) return "/admin/dashboard";
  if (roles.includes("monteur")) return "/monteur/werkbonnen";
  if (
    roles.includes("zzp_owner") ||
    roles.includes("tenantadmin") ||
    roles.includes("controller") ||
    roles.includes("projectleider")
  ) {
    return "/pl";
  }
  return "/pl";
}
